var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.096 9.316 8.19-9.317h-1.94L12.23 8.087 6.551-.001H0L8.59 12.23 0 22h1.94l7.51-8.543L15.45 22H22zm-2.66 3.021-.871-1.218L2.64 1.43h2.98l5.59 7.821.869 1.219 7.265 10.166h-2.982z"
  })));
};
export default SvgTwitter;